import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id A2E311D2-225E-4AD7-948D-D27AD0362D9F
 * name mini-sd
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/mini-sd.svg
 * tags
 */
export const MiniSdIcon = createSvgIcon(<><path d="M6,4A2,2 0 0,0 4,6V18A2,2 0 0,0 6,20H18A2,2 0 0,0 20,18V12L18,10V6A2,2 0 0,0 16,4H6M7,6H9V10H7V6M10,6H12V10H10V6M13,6H15V10H13V6Z" /></>, 'MiniSdIcon');
export default MiniSdIcon